/***
*
*   ICON
*   Render an icon from feather icons
*
*   PROPS
*   color: dark/light/grey/green/orange/blue or hex code
*   pack: icon pack to use, default is feathericons
*   image: image to use (see: https://feathericons.com)
*   className: inject a parent class object
*
**********/

import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

export function Icon(props){

  let color;
  
  const packs = {

    fontawesome: FontAwesomeIcon,
    feather: FeatherIcon
  
  }

  switch (props.color){

    case 'light':
    color = 'var(--sg-icon-light)';
    break;

    case 'dark':
    color = 'var(--sg-icon-dark)';
    break;

    case 'grey':
    color = 'var(--sg-icon-grey)';
    break;

    case 'green':
    color = 'var(--sg-icon-green)';
    break;

    case 'blue':
    color = 'var(--sg-icon-blue)';
    break;

    case 'orange':
    color = 'var(--sg-icon-orange)'
    break;

    case 'red':
    color = 'var(--sg-icon-red)';
    break;

    case 'purple':
    color = 'var(--sg-icon-purple)';
    break;

    default:
    color = props.color;
    break;

  }

  if (props.pack === 'fontawesome')
    library.add(fab);

  const Icon = packs[props.pack || 'feather'];

  return(
    <Icon
      color={ color }
      icon={ props.image }
      size={ props.size || 16 }
      className={ props.className }
    />
  )
}

